<template>
  <ul class="c-list c-list--results">
    <li 
      class="c-list__item"
      v-for="(item, i) in resultsListing"
      v-bind:key="i">
      <component 
        v-if="item"
        v-bind:is="itemComponent"
        v-bind:item="item">
      </component>
    </li>
  </ul>
</template>

<script>
import SearchItemDoc from "./SearchItemDoc.vue";
import SearchItemPage from "./SearchItemPage.vue";

export default {
  name: "SearchListing",
  components: {
    SearchItemDoc,
    SearchItemPage
  },
  props: {
    itemComponent: {
      type: String
    },
    resultsListing: {
      type: Array
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/partnerhub/results/SearchListing.vue